import {createFileRoute, redirect} from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/weight')({
  beforeLoad: () => {
    throw redirect({to: '/tracking/weight', replace: true});
  },
});
